import { useRef } from "react";
import ModalPop from "./ModalPop";
import useDeviceType from "../common/useDeviceType";

const About = () => {
  const isMobile = useDeviceType();

  const aboutList = [
    {
      icon: "/images/about1.png",
      txt1: "365일 24시간",
      txt2: "긴급출동",
    },
    {
      icon: "/images/about2.png",
      txt1: "오차없는",
      txt2: "정직한 견적",
    },
    {
      icon: "/images/about3.png",
      txt1: "무수한 경험",
      txt2: "다양한 작업",
    },
    {
      icon: "/images/about4.png",
      txt1: "최신장비 및",
      txt2: "최고의 인력",
    },
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className=" relative w-full h-full max-w-screen-xl mx-auto">
        <img
          data-aos="fade-up"
          src={isMobile ? "/images/aboutMo.png" : "/images/aboutPc.png"}
          alt="스마트누수"
        />
        <div className="relative w-full h-full lg:px-5 grid grid-cols-2 lg:grid-cols-4 gap-5 mt-5">
          {aboutList.map((v, i) => (
            <div
              key={i}
              className="relative w-full h-full rounded-lg border-2 border-primary p-5 transition lg:hover:-translate-y-2 duration-300"
            >
              <img
                src={v.icon}
                alt="누수탐지"
                className="!relative w-auto h-full max-h-10 mx-auto object-contain"
              />
              <div className="text-secondary mt-2">
                <p className="lg:text-xl 2xl:text-2xl">{v.txt1}</p>
                <p className="lg:text-xl 2xl:text-2xl">{v.txt2}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="relative w-full max-w-screen-md mx-auto h-fit grid grid-cols-2 mt-5 gap-2 lg:gap-5 lg:mt-10">
          <button
            type="button"
            onClick={() => (window.location.href = "tel:010-8912-1202")}
            className={`rounded-2xl bg-secondary lg:px-8 py-2 lg:pt-3 text-xl text-white shadow-md transition hover:brightness-110 active:scale-[0.98]`}
          >
            <h4 className="text-white font-light lg:text-2xl 2xl:text-3xl">
              상담신청
            </h4>
          </button>
          <button
            type="button"
            onClick={openfunc}
            className={`rounded-2xl bg-white border-2 border-red lg:px-8 py-2 lg:pt-3 text-xl text-white shadow-md transition hover:brightness-110 active:scale-[0.98]`}
          >
            <h4 className="text-red font-light lg:text-2xl 2xl:text-3xl">
              긴급출동
            </h4>
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
